
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import { Col, Form } from 'react-bootstrap';
import Tree from '../../../../src/components/Tree/index';
import { useState } from 'react';

const TreeAdvacned = (
  {
    title,
    nodes,
    nodesCount,
    searchText,
    setSearchText,
    treeHandler,
    setSelectedAllNodes,
    selectedAllNodes
  }
) => {
  const [selectedNodes, setSelectedNodes]=useState(selectedAllNodes);

  const handleCheckboxSelect = (nodeId, nodeName) => {
    const treeNode = selectedNodes;
    const selectedNode = treeNode.find((item) => item.id == nodeId);
    if (!selectedNode) {
      const updatedTreeNodes = [...treeNode, { id: nodeId, name: nodeName }];
      setSelectedNodes(updatedTreeNodes);
      setSelectedAllNodes(updatedTreeNodes);
    } else {
      const updatedTreeNodes = treeNode.filter((item) => item.id !== nodeId);
      setSelectedNodes(updatedTreeNodes);
      setSelectedAllNodes(updatedTreeNodes);
    }
  };

  const handleSearch = (searchText) => {
    setSearchText(searchText);
    if (searchText.trim() === '') {
      setSelectedNodes(selectedAllNodes);
    } else {
      const searchNodes = selectedAllNodes.filter(obj =>
        obj.name.toLowerCase().includes(searchText.toLowerCase())
      );
      setSelectedNodes(searchNodes);
    }
  };

  return (
    <>
      <Col>
        <div className='bg-blue w-100 rounded-4 p-3'>
          <h6>{title}</h6>
          {selectedNodes.map((item, index) => {
            return (
              <>
                <div className="d-flex mt-1" key={index}>
                  <Form.Check
                    id={item.id}
                    type="checkbox"
                    className="checkbox-name margin-left-20 mx-2"
                    onChange={(e) => {
                      handleCheckboxSelect(e.target.id, e.target.value);
                    }}
                    checked={selectedAllNodes.find(obj => obj.id == item.id)}
                    value={item.name}
                  />
                  <span>
                    {item.name}
                  </span>
                </div>
              </>
            );
          })}
          <div className="custom-search position-relative mb-3 mt-3">
            <FontAwesomeIcon icon={faSearch} />
            <input
              type="text"
              value={searchText}
              placeholder="Search in list"
              className="form-control bg-white"
              onChange={(e) => handleSearch(e.target.value)}
            />
          </div>
          <Tree
            nodes={nodes}
            treeNodeHandler={treeHandler}
            parentNodesCount={nodesCount}
            selectedAllNodes={selectedAllNodes}
            setSelectedAllNodes={setSelectedAllNodes}
            setSelectedNodes={setSelectedNodes}
          />
        </div>
      </Col>
    </>
  );
};

TreeAdvacned.propTypes = {
  title: PropTypes.string,
  nodes: PropTypes.array,
  nodesCount: PropTypes.number,
  searchText: PropTypes.string,
  setSearchText: PropTypes.func,
  treeHandler: PropTypes.func,
  selectedAllNodes: PropTypes.array,
  setSelectedAllNodes: PropTypes.func,
};

export default TreeAdvacned;